import styled, { css } from 'styled-components';
import { mediaBreakpointUp, gridGutterWidth } from '@whitelabel/helpers/style/grid';
import { spacer, multiply } from '@whitelabel/helpers/style/units';

export const StyledPartnerHeading = styled.header`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: stretch;
  justify-items: stretch;
  margin-bottom: ${spacer};

  ${mediaBreakpointUp('md')`
    margin-bottom: ${multiply(spacer, 2)};
  `}

  ${mediaBreakpointUp('lg')`
    margin-bottom: ${multiply(spacer, 3)};
  `}
`;

const firstItem = css`
  display: flex;
  grid-row: 2;
  grid-column: 1 / 3;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;

  ${mediaBreakpointUp('sm')`
    grid-row: 1;
    grid-column: 1 / 2;
    justify-content: left;
    text-align: start;
  `}
`;

export const StyledTitle = styled.h2`
  ${firstItem}
`;

export const StyledTitleBox = styled.div`
  ${firstItem}
  flex-direction: column;
  .h2 {
    margin-bottom: 0;
  }
  ${mediaBreakpointUp('sm')`
    align-items: flex-start;
  `}
`;

export const StyledPartner = styled.div`
  display: flex;
  grid-row: 1;
  grid-column: 1 / 3;
  align-items: center;
  justify-content: center;

  ${mediaBreakpointUp('sm')`
    grid-column: 2 / 3;
    padding-inline-start: ${gridGutterWidth('sm')};
  `}

  ${mediaBreakpointUp('md')`
    padding-inline-start: ${gridGutterWidth('md')};
  `}

  ${mediaBreakpointUp('lg')`
    padding-inline-start: ${gridGutterWidth('lg')};
  `}
`;

export const StyledPartnerLogo = styled.img`
  max-width: ${multiply(spacer, 11.5)};
  max-height: ${multiply(spacer, 3.5)};

  ${mediaBreakpointUp('sm')`
    max-width: ${multiply(spacer, 8.5)};
    max-height: ${multiply(spacer, 2.5)};
  `}

  ${mediaBreakpointUp('md')`
    max-width: ${multiply(spacer, 13)};
    max-height: ${multiply(spacer, 3.75)};
  `}

  ${mediaBreakpointUp('lg')`
    max-width: ${multiply(spacer, 17)};
    max-height: ${multiply(spacer, 4.375)};
  `}
`;
